module.exports = __webpack_public_path__ + "img/beach.caa8fbf2.svg";